import { render, staticRenderFns } from "./IbanControl.vue?vue&type=template&id=6aee901c&"
import script from "./IbanControl.vue?vue&type=script&lang=js&"
export * from "./IbanControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports